module.exports = __webpack_public_path__ + "img/rouler_positions_5_back.06194373.png";